import React from "react";

const ServicesHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[38rem] w-[38rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/55" />
      </div>

      {/* Content wrapper */}
      <div
        className="
          relative mx-auto w-full max-w-7xl
          px-4 sm:px-6 lg:px-8
          py-16
          sm:py-20
          md:py-24
          lg:py-28
        "
      >
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white">
            Services
            <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
            Outcomes first
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-semibold tracking-tight text-white">
            People-focused. Process-centric.
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
            Engagements designed to reduce risk, strengthen compliance, and deliver measurable quality improvements.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#packages"
              className="inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition shadow-lg"
            >
              View Packages
            </a>
            <a
              href="#process"
              className="inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
            >
              How We Work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
